import type { Response } from 'types/api';
import { deleteRequest, getRequest, patchRequest, postRequest } from 'utils/request';

export type RollAdminMCPKeyResponse = { key: string };
export const rollAdminMCPKey = (): Promise<RollAdminMCPKeyResponse> =>
  postRequest('/admin/mcp/key');

type AdminActionResponse = Response<unknown>;

export const reinitPartnerships = (companyID: string): Promise<AdminActionResponse> =>
  postRequest('/admin/re-init-partnerships', { companyID });

export const cleanupPartnership = (partnershipID: string): Promise<AdminActionResponse> =>
  postRequest('/admin/cleanup-partnership', { partnershipID });

export type GenerateInvoicesParams = { orderIds: string[]; settledExternally: boolean };
export const generateInvoices = (params: GenerateInvoicesParams): Promise<AdminActionResponse> =>
  postRequest('/admin/invoices/generate', params);

export const resyncVariantMappings = (companyId: string): Promise<AdminActionResponse> =>
  postRequest(`/companies/${companyId}/resync-variant-mappings`);

export const deleteCompanyStripe = (companyId: string): Promise<AdminActionResponse> =>
  deleteRequest(`/companies/${companyId}/stripe`);

export const rebuildSearchIndex = (companyId: string): Promise<AdminActionResponse> =>
  postRequest(`/search/${companyId}/index`);

export const testShopifySecret = (companyId: string): Promise<AdminActionResponse> =>
  getRequest(`/test/${companyId}/shopify-secret-status`);

export const setDefaultEDISchemaLive = (documentNumber: number): Promise<AdminActionResponse> =>
  postRequest(`/edi/schemas/${documentNumber}/default/live`, {});

export type MappingConditions = {
  buyerCompanyObjectID: string;
  partnershipID?: string;
  productIDs?: string[];
};

export const resetMappings = (conditions: MappingConditions): Promise<AdminActionResponse> =>
  patchRequest('/products/reset-mappings', conditions);

export const resetMappingImages = (conditions: MappingConditions): Promise<AdminActionResponse> =>
  patchRequest('/products/reset-images', conditions);

export const ensureMappings = (conditions: MappingConditions): Promise<AdminActionResponse> =>
  postRequest('/products/ensure-mappings', conditions);

export const clearAndResyncImages = (conditions: MappingConditions): Promise<AdminActionResponse> =>
  postRequest('/products/resync-images', conditions);

export const resyncPartnershipMappings = (partnershipID: string): Promise<AdminActionResponse> =>
  postRequest(`/products/resync-mappings?partnershipID=${encodeURIComponent(partnershipID)}`);
